<template>
  <header :class="{ 'fixed-header': fixed }">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/images/headerlogo2.svg" alt="Logo" />
        </router-link>
      </div>
      <!-- 桌面端导航 - 直接循环所有菜单数据 -->
      <nav class="desktop-nav" v-if="!isMobile && menuData.length > 0">
        <el-menu
          :default-active="currentActiveKey"
          active-text-color="#ffffff"
          background-color="#2E3675"
          class="el-menu-demo"
          mode="horizontal"
        >
          <!-- 动态生成菜单项，支持任意级嵌套 -->
          <template v-for="menu in menuData">
            <!-- 处理普通菜单项 -->
            <el-menu-item
              v-if="!menu.children || menu.children.length === 0"
              :key="menu.id"
              :index="menu.id + ''"
              @click="handleMenuItemClick(menu.path)"
            >
              {{ $i18n.locale === "zh" ? menu.menu_name : menu.menu_name_en }}
            </el-menu-item>

            <!-- 处理带有子菜单的菜单项 -->
            <el-submenu v-else :key="menu.id" :index="menu.id + ''">
              <template slot="title">
                {{ $i18n.locale === "zh" ? menu.menu_name : menu.menu_name_en }}
              </template>
              <!-- 递归渲染子菜单 -->
              <template v-for="child in menu.children">
                <el-menu-item
                  v-if="!child.children || child.children.length === 0"
                  :key="child.id"
                  :index="child.id + ''"
                  @click="handleMenuItemClick(child.path)"
                >
                  {{
                    $i18n.locale === "zh" ? child.menu_name : child.menu_name_en
                  }}
                </el-menu-item>

                <el-submenu v-else :key="child.id" :index="child.id + ''">
                  <template slot="title">
                    {{
                      $i18n.locale === "zh"
                        ? child.menu_name
                        : child.menu_name_en
                    }}
                  </template>
                  <!-- 支持更深层级的子菜单 -->
                  <template v-for="grandchild in child.children">
                    <el-menu-item
                      :key="grandchild.id"
                      :index="grandchild.id + ''"
                      @click="handleMenuItemClick(grandchild.path)"
                    >
                      {{
                        $i18n.locale === "zh"
                          ? grandchild.menu_name
                          : grandchild.menu_name_en
                      }}
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </nav>
      <div class="search">
        <el-input
          v-model="searchKeyword"
          :placeholder="$t('headerSearchPlaceholder')"
        ></el-input>
        <el-button icon="el-icon-search" @click="handleSearch"></el-button>
      </div>

      <el-dropdown class="publish-button">
        <el-button class="publish" type="primary">
          {{ $t("publish") }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="
              navigateToTravelPublish(
                'https://www.rent.move2china.com/index/detail/upload',
              )
            "
          >
            {{ $t("housingInfo") }}
          </el-dropdown-item>
          <el-dropdown-item
            @click.native="navigateToTravelPublish('/travel/publish')"
          >
            {{ $t("travelRoutes") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- PC + Pad 共用语言按钮 -->
      <!-- <div class="lang-switch" v-if="!isMobile" @click="changeLang">
        <el-button
          size="small"
          type="text"
          style="color: #fff; font-size: 16px; padding: 0px 5px"
        >
          {{ $i18n.locale === "zh" ? "中" : "EN" }}
        </el-button>
      </div> -->
      <div class="lang-switch" v-if="!isMobile" @click="changeLang">
        <el-button size="small" type="text" style="color: #fff; padding: 0 5px">
          <span :class="{ 'active-lang': $i18n.locale === 'zh' }">中</span>
          <span class="split">/</span>
          <span :class="{ 'active-lang': $i18n.locale === 'en' }">EN</span>
        </el-button>
      </div>

      <!-- 个人信息区域 -->
      <div class="user-info" v-if="user && !isMobile">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <el-avatar
              class="avatar"
              :size="40"
              :src="user.avatarimg | avatar"
            ></el-avatar>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="about-me">{{
              $t("aboutMe")
            }}</el-dropdown-item>
            <el-dropdown-item command="merchant">{{
              $t("merchantCert")
            }}</el-dropdown-item>
            <el-dropdown-item command="logout">{{
              $t("logout")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 未登录显示默认头像 -->
      <div class="user-info" v-else-if="!isMobile" @click="goToLogin">
        <el-avatar
          style="cursor: pointer"
          :size="40"
          icon="el-icon-user"
        ></el-avatar>
      </div>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-button" v-if="isMobile">
        <!-- <el-button
          size="small"
          type="text"
          style="color: #fff; margin-right: 10px"
          @click="changeLang"
        >
          {{ $i18n.locale === "zh" ? "中" : "EN" }}
        </el-button> -->
        <el-button
          size="small"
          type="text"
          style="color: #fff; margin-right: 10px"
          @click="changeLang"
        >
          <span :class="{ 'active-lang': $i18n.locale === 'zh' }">中</span>
          <span class="split">/</span>
          <span :class="{ 'active-lang': $i18n.locale === 'en' }">EN</span>
        </el-button>

        <el-button
          type="primary"
          icon="el-icon-menu"
          @click="toggleMobileMenu"
        ></el-button>
      </div>
    </div>

    <!-- 移动端导航菜单 -->
    <div class="mobile-nav" v-if="isMobile && mobileMenuVisible">
      <el-menu
        :default-active="currentActiveKey"
        class="el-menu-vertical-demo"
        @close="mobileMenuVisible = false"
        background-color="#ffffff"
      >
        <!-- 动态生成菜单项，支持任意级嵌套 -->
        <template v-for="menu in menuData">
          <el-menu-item
            v-if="!menu.children || menu.children.length === 0"
            :key="menu.id"
            :index="menu.id + ''"
            @click="handleMenuItemClick(menu.path)"
          >
            {{ $i18n.locale === "zh" ? menu.menu_name : menu.menu_name_en }}
          </el-menu-item>

          <el-submenu v-else :key="menu.id" :index="menu.id + ''">
            <template slot="title">
              {{ $i18n.locale === "zh" ? menu.menu_name : menu.menu_name_en }}
            </template>
            <template v-for="child in menu.children">
              <el-menu-item
                v-if="!child.children || child.children.length === 0"
                :key="child.id"
                :index="child.id + ''"
                @click="handleMenuItemClick(child.path)"
              >
                {{
                  $i18n.locale === "zh" ? child.menu_name : child.menu_name_en
                }}
              </el-menu-item>

              <el-submenu v-else :key="child.id" :index="child.id + ''">
                <template slot="title">
                  {{
                    $i18n.locale === "zh" ? child.menu_name : child.menu_name_en
                  }}
                </template>
                <template v-for="grandchild in child.children">
                  <el-menu-item
                    :key="grandchild.id"
                    :index="grandchild.id + ''"
                    @click="handleMenuItemClick(grandchild.path)"
                  >
                    {{
                      $i18n.locale === "zh"
                        ? grandchild.menu_name
                        : grandchild.menu_name_en
                    }}
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </el-submenu>
        </template>

        <el-submenu index="user" v-if="user">
          <template slot="title">
            <el-avatar :size="30" :src="user.avatarimg | avatar"></el-avatar>
          </template>
          <el-menu-item @click="handleMenuItemClick('/about-me')">{{
            $t("aboutMe")
          }}</el-menu-item>
          <el-menu-item @click="handleMenuItemClick('/about-me/merchant-auth')">
            {{ $t("merchantCert") }}
          </el-menu-item>
          <el-menu-item index="logout">{{ $t("logout") }}</el-menu-item>
        </el-submenu>
        <el-menu-item v-else @click="goToLogin">
          <el-avatar :size="40" icon="el-icon-user"></el-avatar>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 移动端/Pad 端悬浮发布 Icon -->
    <div class="floating-publish" v-if="showFloatingPublish">
      <div class="publish-icon-group">
        <div class="publish-icon-item">
          <img
            src="../assets/images/release_house.png"
            alt="上传"
            @click="
              navigateToTravelPublish(
                'https://www.rent.move2china.com/index/detail/upload',
              )
            "
          />
          <span>{{ $t("postHousing") }}</span>
        </div>
        <div class="publish-icon-item">
          <img
            src="../assets/images/travel_route.png"
            alt="路线"
            @click="navigateToTravelPublish('/travel/publish')"
          />
          <span>{{ $t("postTravel") }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    fixed: {
      type: Boolean,
      default: true,
    },
    inherit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchKeyword: "",
      isMobile: false,
      mobileMenuVisible: false,
      user: {},
      menuData: [],
      showFloatingPublish: false,
      isHomePage: false,
      routeChangeTimer: null,
    };
  },
  computed: {
    activePath() {
      return this.$route.path;
    },
    currentActiveKey() {
      const findActiveMenuId = (menus) => {
        for (const menu of menus) {
          if (menu.path?.startsWith("http")) continue;
          if (this.$route.path === menu.path) {
            return menu.id + "";
          }
          if (menu.children?.length) {
            const childId = findActiveMenuId(menu.children);
            if (childId) return childId;
          }
        }
        return "";
      };
      return findActiveMenuId(this.menuData);
    },
  },
  mounted() {
    this.isHomePage = this.$route.path === "/";
    this.checkScreenSize();
  },
  created() {
    const userInfo = this.$cookies.get("userInfo");
    this.user = userInfo;
    this.checkScreenSize();
    this.fetchMenuData();
    window.addEventListener("resize", this.checkScreenSize);
    this.isHomePage = this.$route.path === "/";
  },
  watch: {
    $route(to) {
      this.isHomePage = to.path === "/";
      clearTimeout(this.routeChangeTimer);
      this.routeChangeTimer = setTimeout(() => {
        this.checkScreenSize();
      }, 100);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    // 中英文切换
    changeLang() {
      const lang = this.$i18n.locale === "zh" ? "en" : "zh";
      this.$i18n.locale = lang;
      // 语言切换，标记列表需要刷新
      localStorage.setItem("lang", lang);
    },

    async fetchMenuData() {
      try {
        const response = await this.$get("/get_menu");
        this.menuData = response.data.data || [];
      } catch (error) {
        console.error("获取菜单数据失败:", error);
      }
    },

    jumpToExternal(url) {
      window.open(url, "_blank");
    },
    goToLogin() {
      this.$router.push("/login-register");
      if (this.isMobile) {
        this.mobileMenuVisible = false;
      }
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      const isPad = window.innerWidth >= 768 && window.innerWidth < 1024;
      this.showFloatingPublish = (this.isMobile || isPad) && this.isHomePage;
      if (!this.isMobile && !isPad) {
        this.mobileMenuVisible = false;
      }
    },
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
    },
    handleSelect(key) {
      console.log(key, "key");
      if (key == null) return;
      if (key == "logout") {
        this.$cookies.remove("userInfo");
        this.$message({
          message: this.$t("logoutSuccess"),
          type: "success",
          duration: 800,
          onClose: () => {
            this.$router.push({ path: "/" });
            window.location.reload();
          },
        });
      }
      this.$router.push(key);
      if (this.isMobile) {
        this.mobileMenuVisible = false;
      }
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        this.$router.push({
          path: "/travel/route-list",
          query: { keyword: this.searchKeyword.trim() },
        });
      } else {
        this.$message.warning(this.$t("pleaseEnterContent"));
      }
    },
    handleCommand(command) {
      switch (command) {
        case "about-me":
          this.$router.push("/about-me");
          break;
        case "merchant":
          this.$router.push("/about-me/merchant-auth");
          break;
        case "logout":
          this.$post("/logout").then((res) => {
            if (res.data.code === 1) {
              this.$cookies.remove("userInfo");
              this.$message({
                message: this.$t("logoutSuccess"),
                type: "success",
                duration: 800,
                onClose: () => {
                  this.$router.push({ path: "/" });
                  window.location.reload();
                },
              });
            } else {
              console.error("退出登录失败");
            }
          });
          break;
      }
    },
    navigateToTravelPublish(path) {
      console.log("path", path);
      if (path && path.startsWith("http")) {
        window.open(path, "_blank");
        return;
      } else {
        this.$router.push(path);
      }
    },
    handleMenuItemClick(path) {
      if (!path) return;
      if (path.startsWith("http")) {
        window.open(path, "_blank");
        if (this.isMobile) {
          this.mobileMenuVisible = false;
        }
        return;
      }
      this.$router.push(path);
      if (this.isMobile) {
        this.mobileMenuVisible = false;
      }
    },
  },
};
</script>

<style scoped>
header {
  background-color: #2e3675;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  z-index: 1000;
}

.container {
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  flex-wrap: wrap;
}

/* 语言切换按钮样式 */
.lang-switch {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

/* 搜索框默认样式（大屏） */
.search {
  height: 50px;
  width: 18%;
  display: flex;
  align-items: center;
  margin-right: 20px;
  position: relative;
  flex-shrink: 1;
}

.logo {
  height: 80px;
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  margin: 0px 40px;
}

.desktop-nav {
  flex: 1;
  text-align: right;
}

.desktop-nav .el-menu-demo {
  border-bottom: none;
}

.desktop-nav .el-menu-demo .el-menu-item,
.desktop-nav .el-submenu ::v-deep .el-submenu__title {
  font-size: 18px;
  padding: 0px 15px;
}

.el-menu-demo .el-menu-item:hover,
.el-menu-demo ::v-deep .el-submenu__title:hover,
.el-menu .el-menu-item:hover {
  color: #fff;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}

.search .el-icon-search {
  font-size: 16px;
}

.search .el-autocomplete {
  width: 100%;
}

.search button {
  position: absolute;
  right: 0px;
}

.publish-button {
  width: 100px;
}

::v-deep.publish-button .el-button--normal {
  padding: 12px 15px;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-info .avatar {
  cursor: pointer;
}

.user-name {
  margin: 0 10px;
}

.mobile-menu-button {
  text-align: right;
}

.mobile-nav {
  position: absolute;
  left: 0;
  width: 100%;
  background-color: #000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

::v-deep .el-input--small .el-input__inner {
  height: 44px !important;
  line-height: 44px;
}

/* 悬浮发布 Icon 容器 */
.floating-publish {
  position: fixed;
  bottom: 100px;
  right: 20px;
  z-index: 999;
}

/* Icon 组布局 */
.publish-icon-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* 单个 Icon 项 */
.publish-icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.publish-icon-item img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.publish-icon-item span {
  margin-top: 5px;
  font-size: 12px;
  color: #333;
  background-color: #fff;
  padding: 2px 8px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.publish-icon-item:hover {
  transform: translateY(-3px);
}

/* 语言切换文字样式 */
.lang-switch span,
.mobile-menu-button span {
  font-size: 14px;
  font-weight: normal;
}
/* 激活的语言：加大字号 + 加粗 */
.active-lang {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #ffdd55;
}
/* 分隔符 / 样式 */
.split {
  margin: 0 4px;
  font-size: 14px;
  opacity: 0.8;
}

/* 小屏时搜索框占满整行 */
@media (max-width: 1024px) {
  .search {
    width: 100% !important;
    margin-right: 0;
    order: 3;
  }

  /* 调整导航和用户信息的排列方式 */
  .desktop-nav,
  .user-info {
    text-align: center;
  }

  /* 隐藏发布按钮（根据需求调整） */
  .publish-button {
    display: none;
  }
}

/* 移动端适配 */
@media (max-width: 767px) {
  .logo img {
    margin: 0;
  }
  header {
    padding: 0;
  }
  .desktop-nav,
  .user-info {
    display: none;
  }
  .search {
    padding-bottom: 10px;
  }
}

@media (min-width: 768px) {
  .mobile-menu-button,
  .mobile-nav .el-submenu {
    display: none;
  }
}
</style>
<style>
.el-menu--horizontal .el-submenu {
  margin-right: 10px;
}

.el-menu--horizontal .el-submenu ::v-deep .el-submenu__title {
  padding: 0 15px;
}

.el-menu--horizontal .el-submenu ::v-deep .el-submenu__icon-arrow {
  right: 10px;
}

.mobile-nav .el-submenu ::v-deep .el-submenu__title {
  padding-left: 30px;
}

.mobile-nav .el-submenu .el-submenu ::v-deep .el-submenu__title {
  padding-left: 40px;
}

.mobile-nav .el-submenu .el-submenu .el-submenu ::v-deep .el-submenu__title {
  padding-left: 50px;
}
</style>
